import { get, post, convertToQueryString } from "./base";

export const getPatients = async (filters) => {
  try {
    let querystring = convertToQueryString(filters);
    const response = await get("/Pacientes?" + querystring);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error retrieving patients:", error);
  }
};

//Return patients filters option for select
export const getPatientsFilters = async () => {
  try {
    const response = await get("/Pacientes/ObtenerListadoFiltrosBusqueda");
    const data = await response.data;

    return data;
  } catch (error) {
    console.error("Error retrieving filters:", error);
  }
};

export const getPresumptivePatientsFilters = async () => {
  try {
    const response = await get("/Pacientes/ObtenerListadoFiltrosBusqueda");
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error retrieving patients:", error);
  }
};
// Presumptive patient List
export const getPresumptivePatients = async (filters) => {
  try {
    //Convert filters in querystring for get and validate if different to null or undefined
    const response = await get(
      "/pacientes/presumptives?" + convertToQueryString(filters)
    );
    const data = await response.data;
    return data;
    // let data = require('./data/patientPresumptive.json');
    // return data;
  } catch (error) {
    console.error("Error retrieving patients:", error);
    return [];
  }
};

export const enrollmentPatient = async (patient) => {
  return await post("/pacientes/enrollment", patient);
};

//Get Questionnaries of Patient
export const getQuestionnariesHistory = async (id) => {
  try {
    const response = await get(
      "/pacientes/questionairesHistory?insuredMember=" + id
    );
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error retrieving patients:", error);
    return [];
  }
};
export const getQuestionnaries = async (id) => {
  try {
    const response = await get("/questionaires?insuredMember=" + id);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error retrieving patients:", error);
    return [];
  }
};

export const saveQuestionnary = async (patient) => {
  return await post("/pacientes/questionaires", patient);
};

//Demographic data of patient
export const getPatientDemographics = async (id) => {
  try {
    const response = await get("/Pacientes/demographics?insuredMember=" + id);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error retrieving demographics:", error);
    return [];
  }
};

export const getHealthProfile = async (id) => {
  try {
    const response = await get("/Pacientes/healthProfile?insuredMember=" + id);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error retrieving health profile:", error);
    return [];
  }
};
export const updatePatientStatus = async (patient) => {
  return await post("/pacientes/updatePatientStatus", patient);
};

export const obtenerDocumentaciones = async (affiliate) => {
  try {
    const response = await get(`/Documentacion/archivos?afiliado=${affiliate}`);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error obteniendo documentaciones:", error);
    return [];
  }
};

export const obtenerComentarios = async (affiliate) => {
  try {
    const response = await get(
      `/Documentacion/comentarios?afiliado=${affiliate}`
    );
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error obteniendo comentarios :", error);
    return [];
  }
};

export const agregarComentario = async (data) => {
  try {
    const response = await post(`/Documentacion/archivo`, data);
    return response.data;
  } catch (error) {
    throw new Error("Error creando actividad : " + error.message);
  }
};

export const agregarDocumentacion = async (data) => {
  try {
    const response = await post(`/Documentacion/archivo`, data);
    return response.data;
  } catch (error) {
    throw new Error("Error creando actividad : " + error.message);
  }
};

export const getNeighborhoods = async (id) => {
  try {
    const response = await get(
      "/Pacientes/ObtenerSectoresPorMunicipio?municipioCd=" + id
    );
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Error retrieving neighborhoods:", error);
    return [];
  }
};
